import LeaseMappingApi from 'api-client/LeaseMapping.api'

const LeaseMappingService = {
  getAllLeaseMappings() {
    return LeaseMappingApi.getAllLeaseMappings()
  },
  createLeaseMapping(payload) {
    return LeaseMappingApi.createLeaseMapping(payload)
  },
  deleteLeaseMapping(debtorId, dealerId) {
    return LeaseMappingApi.deleteLeaseMapping(debtorId, dealerId)
  },
}

export default LeaseMappingService
